import { PercentageUpDownType } from '@labrav/react-components/lib/@types/v2/components/PercentageUpDown'
import { productDetailDate } from '../../../common/utils/productCreationUtil'
import { KeywordItem } from '../../../modules/mpsSeo/reducer'

export const getCompetitorLegendIds = (item?: KeywordItem) =>
  item?.competitors?.map(competitorItem => competitorItem?.Id || 'self') ?? []

export const CHART_RANK_NOTE =
  'Competitors ranking beyond position 40 are omitted from the chart below.'

export const RANKING_REFRESH_TOOLTIP_NOTE = 'Data refreshes weekly.'

export const getRankingRefreshNote = (
  updatedAt?: string,
  timeZone?: string
) => {
  if (!updatedAt) {
    return 'Ranking refreshes weekly.'
  }

  const lastRefreshedAt = productDetailDate(updatedAt, timeZone).modifiedDate
  return `Ranking refreshes weekly. Last refreshed on ${lastRefreshedAt}.`
}

export const formatShortChartDate = (value: Date, timeZone?: string) =>
  productDetailDate(value, timeZone).shortDate

export const getRankTooltip = (
  rankChange?: number,
  initialRank?: number,
  currentRank?: number
) => {
  if (!rankChange || !initialRank || !currentRank)
    return { tooltipMsg: '', upDown: 'right' as PercentageUpDownType }
  const upDown = (rankChange > 0 ? 'up' : 'down') as PercentageUpDownType
  return {
    tooltipMsg: `Rank moved ${Math.abs(
      rankChange
    )} position ${upDown}. From ${initialRank} to ${currentRank}.`,
    upDown,
  }
}

export const getStartAndEndDate = (data: any[]) => {
  if (!data.length)
    return {
      startDate: null,
      formattedStartDate: null,
      endDate: null,
      formattedEndDate: null,
    }

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      year: 'numeric',
    })
  }

  const firstDataArray = data[0]?.data
  const startDate = firstDataArray?.length ? firstDataArray[0].x : null
  const formattedStartDate = startDate ? formatDate(startDate) : null

  const lastDataArray = data[data.length - 1]?.data
  const endDate = lastDataArray?.length
    ? lastDataArray[lastDataArray.length - 1].x
    : null
  const formattedEndDate = endDate ? formatDate(endDate) : null

  return { startDate, formattedStartDate, endDate, formattedEndDate }
}
